import { Component, OnInit } from '@angular/core';
//import { FormBuilder, FormControl, FormGroup,Validators } from '@angular/forms';
import { WebService } from '../services/web/web.service';
import {SocketService} from '../services/socket/socket.service';
@Component({
  selector: 'app-addmenu',
  templateUrl: './addmenu.component.html',
  styleUrls: ['./addmenu.component.css']
})
export class AddmenuComponent implements OnInit {
model: any = {};

 parentFlag:boolean = true;
 childFlag:boolean = true;
 // form:FormGroup;
  message; 
  messageClass;
  parentMenu;
  appnames;
  selectedappname;
  constructor(private httpService:WebService,private socketService:SocketService) {
  	
  		this.httpService.getMethod('/menuroute/getappname').then(appdata=>{
  			console.log(appdata)
  			this.appnames = appdata.json();
  			this.appnames = this.appnames.appnames;
  			console.log(this.appnames);
  		}).catch(err=>{
  			console.log(err);
  		})

      //var reviewObj={"user_name":"vijay","appname":'cochin',"id":'vijay12345'}
      //for T1 terminal
     
    




/*let liveLength =  liveData02_06.length
var letK=0;
     var k=0;
     var tempFlag = true
     var liveVar = setInterval( ()=> {
         //console.log("liveLength " + k)
                this.socketService.sendMessage(liveData02_06[k])
                k++;

                if(liveData02_06[k]['uniqueId'] == '00cdb7b0aaa4181b' && tempFlag){

                    tempFlag = false;
                    letK=k;

                     //this.socketService.sendAlertMessage(liveData02_06[k-1]);
                     //this.socketService.sendAlertMessage(liveData02_06[k]);
                     console.log("message has to be send")
                     console.log(liveData02_06[k-1])
                     setTimeout(()=>{
                       this.socketService.sendAlertMessage(liveData02_06[letK-1])
                       this.socketService.sendAlertMessage(liveData02_06[letK])
                    },4000);
                }
                if(k >= liveData02_06.length)
                      clearInterval(liveVar);
            }, 1000);
*/
/*let reviewObjLength =  reviewObj.length
     var k=0;
     var reviewObjVar = setInterval( ()=> {
         console.log("reviewObj " + k)
                this.socketService.sendMessage(reviewObj[k])
                k++;
                if(k >= reviewObj.length)
                      clearInterval(reviewObjVar);
            }, 3000); //5 sec
*/
       
 // setTimeout(()=>{
 //       this.socketService.sendAlertMessage(liveData02_06[letK-1])
 //       this.socketService.sendAlertMessage(liveData02_06[letK])
 //   },4000);


/*setTimeout(()=>{
    this.socketService.sendAlertMessage(terminal3Data[1])
},15000)
*/
      


    /* var  l=reviewObj2.length-1;

     var reviewObj2ReversVar = setInterval( ()=> {
         console.log("reviewObj2ReversVar  " + l)
                this.socketService.sendMessage(reviewObj2[l])
                l--;
                if(l== 0)
                      clearInterval(reviewObj2ReversVar);
            }, 3000); //5 sec

      
     

      let dataLenghtT3 =  terminal3Data.length
     var i=0;
     var t3Var = setInterval( ()=> {
         console.log("t3Var " + i)
                this.socketService.sendMessage(terminal3Data[i])
                i++;
                if(i>= terminal3Data.length)
                      clearInterval(t3Var);
            }, 3000); //5 sec


     var  j=terminal3DataReverce.length-1;

     var t3ReversVar = setInterval( ()=> {
         console.log("terminal3DataReverce " + j)
                this.socketService.sendMessage(terminal3DataReverce[j])
                j--;
                if(j== 0)
                      clearInterval(t3ReversVar);
            }, 3000); //5 sec

*/


     

      
   }
 
  ngOnInit() {
  }
   parentFlagCheck()
  {
  	console.log("parentFlag" + this.parentFlag);
  }
  onChange(e){
  	console.log(this.model)
  	console.log(this.selectedappname);
  	console.log(e);
  	this.selectedappname = e;
  	console.log(this.selectedappname);
  	this.httpService.getResponse('/menuroute/appmenu',{appname:this.model['selectedappname']}).then(parentMenu=>{
			console.log(parentMenu.json())
			this.parentMenu = parentMenu.json();
			this.parentMenu = this.parentMenu.parentMenu;
			
		}).catch(err=>{
			console.log(err);
		})
  }
  doParent(){
		
		this.parentFlag = !this.parentFlag;
	}
	doChild(){

		this.parentFlag = !this.parentFlag;

		
	}


onCreatMenu(){
		console.log(this.selectedappname);
		console.log(this.model);
		var parent_id="0";
		if(!this.parentFlag){
			//parent_id = this.form.get('parentmenu').value;
			parent_id = this.model.parentmenu;
		}
		this.model['parent_id'] = parent_id

		console.log(this.model);
		this.httpService.getResponse('/menuroute/createmenu',this.model).then(menuData=>{
			this.message = "Menu cretated Succesfully";
	    	this.messageClass= "alert alert-success";
		}).catch(err=>{
			this.message = "Error to Creat Menu !";
	    	this.messageClass="alert alert-danger";
		})

		  

	    
	}

}



// WEBPACK FOOTER //
// ./src/app/addmenu/addmenu.component.ts